export enum PopupType {
  LOGIN = 'popup_login',
  AI_TOOLS_SUBSCRIPTION = 'js_ai_brain_tools_prices_popup',
}

export enum EditorPopupId {
  GEN_ONE_PREMIUM_AI_RESPONSE = 'genOnePremiumAiResponse',
  PREMIUM_ANSWER_USED = 'premiumAnswerUsed',
  GOOGLE_ADSENSE = 'googleAdsense',
  GEN_FREE_AI_RESPONSE = 'genFreeAiResponse',
  GEN_PREMIUM_AI_RESPONSE = 'genPremiumAiResponse',
}
